import React, {useEffect, useState} from 'react';
import {throttle} from '../../utils/util';

interface IUseScroll {
  bottomDistance?:number;
  onTouchBottom:()=>void;
  onScroll?:(e:any)=>void;
  wait?:number;
}

export default (props:IUseScroll)=>{
  const [wrapper, setWrapper] = useState(null as any);

  const {bottomDistance = 1000, onTouchBottom, onScroll, wait = 150} = props;
  useEffect(()=>{
    let maxScroll = 0;
    let lastScrollHeight = 0;
    let lastTriggerTime = 0; // 记录上次触发时间
    
    const onScrollEvent = throttle((e:any)=>{
      if(e && e.target) {
        if(onScroll) {
          onScroll(e);
        }
        const {offsetHeight, scrollTop, scrollHeight} = e.target;
        
        // 检查页面高度变化，如果变化了重置maxScroll，允许在新高度下重新触发
        if(scrollHeight !== lastScrollHeight && lastScrollHeight > 0) {
          // console.log('页面高度变化，从', lastScrollHeight, '到', scrollHeight);
          maxScroll = 0; // 重置，允许在新内容下重新开始计算
          lastTriggerTime = 0; // 重置触发时间，允许立即触发
        }
        lastScrollHeight = scrollHeight;
        
        // 使用更严格的触底条件，确保真正接近底部才触发
        const actualBottomDistance = Math.min(bottomDistance, 800); // 限制最大距离
        
        if((offsetHeight + scrollTop + actualBottomDistance) >= scrollHeight) {
          // 快要到底了
          const now = Date.now();
          
          // 关键修改：增加最小触发间隔（500ms），防止过度触发
          // 同时保持原来的逻辑：只要比maxScroll大就触发
          if(maxScroll < scrollTop && (now - lastTriggerTime) > 500) {
            // console.log('触底检测触发，scrollTop:', scrollTop, 'maxScroll:', maxScroll, 'scrollHeight:', scrollHeight);
            lastTriggerTime = now;
            onTouchBottom && onTouchBottom();
          }
          // 更新maxScroll（原来的逻辑）
          maxScroll = scrollTop;
        }
      }
    }, wait);

    if(wrapper && wrapper.current) {
      wrapper.current.addEventListener('scroll', onScrollEvent);
    }

    return ()=>{
      if(wrapper && wrapper.current) {
        wrapper.current.removeEventListener('scroll', onScrollEvent);
      }
    }
  }, [wrapper]);

  return {
    setWrapper
  }
}
